export class QuestionOptionsConstantService{
    static questionTypes = {
        'LIKERT': {
            'label': $localize `Likert`,
            'value': 'LIKERT',
            'create_title': $localize `Create a custom <span style="color:#32735F">Likert</span> question`,
            'create_subtitle': $localize `A Likert question measures beliefs, attitudes and opinions about the organisation.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">Likert</span> question`,
            'edit_subtitle': $localize `A Likert question measures beliefs, attitudes and opinions about the organisation.`,
            'options':{
                'has_changed': false,
                'is_editable': false,
                'options':[
                    {
                        'placeholder': '',
                        'text': $localize`Strongly agree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Agree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Neither agree nor disagree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Disagree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Strongly disagree`,
                        'comments_required': false,
                    },
                ]
            }
        },
        'LIKERT_WITH_NOT_APPLICABLE': {
            'label': $localize `Likert`,
            'value': 'LIKERT_WITH_NOT_APPLICABLE',
            'create_title': $localize `Create a custom <span style="color:#32735F">Likert</span> question`,
            'create_subtitle': $localize `A Likert question measures beliefs, attitudes and opinions about the organisation.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">Likert</span> question`,
            'edit_subtitle': $localize `A Likert question measures beliefs, attitudes and opinions about the organisation.`,
            'options':{
                'has_changed': false,
                'is_editable': false,
                'options':[
                    {
                        'placeholder': '',
                        'text': $localize`Strongly agree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Agree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Neither agree nor disagree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Disagree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Strongly disagree`,
                        'comments_required': false,
                    },{
                        'placeholder': '',
                        'text': $localize`Not applicable`,
                        'comments_required': false,
                    },
                ]
            }
        },
        'COMPETENCY': {
            'label': $localize `Measured`,
            'value': 'COMPETENCY',
            'create_title': $localize `Create a custom <span style="color:#32735F">measured</span> question`,
            'create_subtitle': $localize `A measured question elicits a selection from a list of predefined options.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">measured</span> question`,
            'edit_subtitle': $localize `A measured question elicits a selection from a list of predefined options.`,
            'options':{
                'has_changed': false,
                'is_editable': false,
                'options':[
                {
                    'placeholder': '',
                    'text': $localize`Always exceeded expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Often exceeded expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Occasionally exceeded expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Met expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Occasionally fell short of expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Often fell short of expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`Never met expectations`,
                    'comments_required': false,
                },{
                    'placeholder': '',
                    'text': $localize`N/A`,
                    'comments_required': false,
                }
            ]}
        },
        'TEXT_MULTI_LINE': {
            'label': $localize `Textbox`,
            'value': 'TEXT_MULTI_LINE',
            'create_title': $localize `Create a custom <span style="color:#32735F">textbox</span> question`,
            'create_subtitle': $localize `A textbox question allows respondents to provide an answer in text form.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">textbox</span> question`,
            'edit_subtitle': $localize `A textbox question allows respondents to provide an answer in text form.`,
            'options':{
                'has_changed': false,
                'is_editable': false,
                'single_line': false,
                'multiple_line': true
            }
        },
        'TEXT_SINGLE_LINE':{
            'label': $localize `Textbox`,
            'value': 'TEXT_SINGLE_LINE',
        },
        'RADIO_BUTTON_TOGGLE': {
            'label': $localize `Yes/No`,
            'value': 'RADIO_BUTTON_TOGGLE',
            'create_title': $localize `Create a custom <span style="color:#32735F">yes/no</span> question`,
            'create_subtitle': $localize `A yes/no question is used to elicit either an affirmative or negative response.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">yes/no</span> question`,
            'edit_subtitle': $localize `A yes/no question is used to elicit either an affirmative or negative response.`,
            'options':{
                'has_changed': false,
                'is_editable': false,
                'options':[
                    {
                        'placeholder': '',
                        'text': $localize`No`,
                        'comments_required': true,
                    },{
                        'placeholder': '',
                        'text': $localize`Yes`,
                        'comments_required': true,
                    }
                ]
            }
        },
        'RADIO_BUTTON_TOGGLE_TEXT':{
            'label': $localize `Yes/No`,
            'value': 'RADIO_BUTTON_TOGGLE_TEXT',
        },
        'DROPDOWN': {
            'label': $localize `Dropdown`,
            'value': 'DROPDOWN',
            'create_title': $localize `Create a custom <span style="color:#32735F">dropdown</span> question`,
            'create_subtitle': $localize `A dropdown question allows respondents to choose one answer from a dropdown list.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">dropdown</span> question`,
            'edit_subtitle': $localize `A dropdown question allows respondents to choose one answer from a dropdown list.`,
            'options':{
                'has_changed': false,
                'is_editable': true,
                'options': [
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    },
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    }
                ]
            }
        },
        'DROPDOWN_TEXT': {
            'label': $localize `Dropdown`,
            'value': 'DROPDOWN_TEXT',
        },
        'RADIO_BUTTON': {
            'label': $localize `Radio button`,
            'value': 'RADIO_BUTTON',
            'create_title': $localize `Create a custom <span style="color:#32735F">radio button</span> question`,
            'create_subtitle': $localize `A radio button question allows respondents to select one answer from a list.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">radio button</span> question`,
            'edit_subtitle': $localize `A radio button question allows respondents to select one answer from a list.`,
            'options':{
                'has_changed': false,
                'is_editable': true,
                'options': [
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    },
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    }
                ]
            }
        },
        'RADIO_BUTTON_TEXT': {
            'label': $localize `Radio button`,
            'value': 'RADIO_BUTTON_TEXT',
        },
        'MATRIX': {
            'label': $localize `Matrix`,
            'value': 'MATRIX',
            'create_title': $localize `Create a custom <span style="color:#32735F">matrix</span> question`,
            'create_subtitle': $localize `A matrix question displays multiple row items and answer options in a grid.`,
            'edit_title': $localize `Edit a custom <span style="color:#32735F">matrix</span> question`,
            'edit_subtitle': $localize `A matrix question displays multiple row items and answer options in a grid.`,
            'options':{
                'has_changed': false,
                'is_editable': true,
                'options':[
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    },
                    {
                        'placeholder': $localize`Enter an option`,
                        'text': '',
                        'comments_required': true
                    }
                ],
                'categories': [
                    {
                        'placeholder': $localize`Enter a section title`,
                        'text': '',
                        'rows': [
                            {
                                'placeholder': $localize`Add a row item`,
                                'text': '',
                            },
                            {
                                'placeholder': $localize`Add a row item`,
                                'text': '',
                            }
                        ]
                    }
                ]
            }
        }
    }
    static metricsRefMapping = { 
        'Ability to learn': 'Personal attributes', 
        'Accountability': 'Personal attributes', 
        'Adaptability and flexibility': 'Personal attributes', 
        'Administration skills': 'Role-specific', 
        'Ambition': 'Personal attributes', 
        'Analytical skills': 'Role-specific', 
        'Attendance, punctuality and reliability': 'Role-specific', 
        'Attention to detail': 'Personal attributes', 
        'Attitude': 'Personal attributes', 
        'Change management': 'Role-specific', 
        'Commercial acumen': 'Personal attributes', 
        'Computer literacy': 'Role-specific', 
        'Conduct and behaviour': 'Personal attributes', 
        'Confidence': 'Personal attributes', 
        'Conflict management': 'Role-specific', 
        'Customer service': 'Role-specific', 
        'Decision making': 'Role-specific', 
        'Emotional empathy': 'Personal attributes', 
        'Entrepreneurship': 'Personal attributes', 
        'Ethics and integrity': 'Personal attributes', 
        'Feedback and criticism': 'Role-specific', 
        'Finance management': 'Role-specific', 
        'Follow instructions': 'Role-specific', 
        'Health and safety': 'Role-specific', 
        'Honesty and integrity': 'Personal attributes', 
        'Initiative': 'Personal attributes', 
        'Inquisitiveness': 'Personal attributes', 
        'Interpersonal skills': 'Personal attributes', 
        'Leadership': 'Role-specific', 
        'Level of autonomy': 'Role-specific', 
        'Listening skills': 'Personal attributes', 
        'Motivation': 'Personal attributes', 
        'Negotiation skills': 'Role-specific', 
        'Numeracy skills': 'Role-specific', 
        'Organisation and planning': 'Role-specific', 
        'Overall performance': 'Role-specific', 
        'Patience': 'Personal attributes', 
        'People management': 'Role-specific', 
        'Personal presentation': 'Personal attributes', 
        'Political astuteness': 'Role-specific', 
        'Prioritise effectively': 'Role-specific', 
        'Problem solving': 'Role-specific', 
        'Professionalism': 'Role-specific', 
        'Project management': 'Role-specific', 
        'Relationships': 'Personal attributes', 
        'Report writing': 'Role-specific', 
        'Responsibility': 'Role-specific', 
        'Stakeholder management': 'Role-specific', 
        'Strategic thinking': 'Role-specific', 
        'Stress management': 'Role-specific', 
        'Targets and KPIs': 'Role-specific', 
        'Teamwork': 'Role-specific', 
        'Technical knowledge': 'Role-specific', 
        'Time management': 'Role-specific', 
        'Training and development': 'Role-specific', 
        'Verbal communication': 'Personal attributes', 
        'Work ethic': 'Personal attributes', 
        'Work under pressure': 'Role-specific', 
        'Written communication': 'Personal attributes' 
    }
}